<template>
	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="x" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleQuestions()">
			<div class="featherlight-content" id="participant_form">
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleQuestions()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;">
					<div class="constraint">
						<form id="question_form" class="form_style">
							<input type="hidden" v-model="load_date">
							<template v-for="question_group in question_groups">
				
								<h2 v-if="question_group.values.heading">{{ question_group.values.heading }}</h2>
								<div class="question_group">
									<template v-if="question_group.values.per_participant">
										<div class="participant_questions" v-for="participant in participants">
											<h4>{{ participant.name }}</h4>
											<template v-for="question in question_group.repeatables">
												<div is="form-field" :question="question" :participant_id="participant.id" :read_only="read_only"></div>
											</template>
										</div>
									</template>

									<template v-else v-for="question in question_group.repeatables">
										<div is="form-field" :question="question" :participant_id="0" :read_only="read_only"></div>
									</template>
								</div>

							</template>

							<p class="half" style="margin-left: auto;" v-if="read_only==false">
								<button type="submit" class="button solid arrow wide medium" v-on:click.prevent="submitForm()" :style="'--accent:' + this.accent">Save</button>
							</p>
						</form>

					</div>
				</section>

			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'uuid',
		'accent',
		'read_only'
	],

	data: () => {
		return {
			participants: {},
			question_groups: {},
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			errors: [],
			shouldShow: false,
			saving: false,
			load_date: null
		}
	},

	computed: {

	},

	watch: {

	},

	created() {

	},

	mounted() {
		
	},

	methods: {

		...mapActions(['addAlert']),

		getQuestions: function () {
			axios.post('/ajax/getQuestions', {
				uuid: this.uuid
			})
			.then(response => {
				this.question_groups = response.data
				this.getParticipants();
				this.load_date = new Date().toISOString();
			})
			.catch(error => {
				console.log(error);
			});
		},

		getParticipants: function(){
			axios.post('/ajax/getParticipants', {
				uuid: this.uuid
			})
			.then(response => {
				this.participants = response.data
			})
			.catch(error => {
				console.log(error);
			});
		},

		toggleQuestions: function(){
			if (this.shouldShow == true) {
				this.shouldShow = false;
				this.errors = [];
				this.participants = {};
				this.question_groups = {};
			}else{
				this.shouldShow = true;
				this.getQuestions();
			}
		},

		splitOptions: function (string) {
			string = string.replace(/(?:\r\n|\r|\n)/g, '|'); // replace line breaks with pipe character
			var array = string.split("|"); // split on the pipe
			array = array.filter(function (el) { return el; }); // filter blank elements
			return array;
		},

		submitForm: function() {
			var self = this;
			axios.post('/ajax/postQuestionsForm', {
				uuid: this.uuid,
				answers: $('#question_form').serialize(),
				load_date: this.load_date
			})
			.then(response => {
				if(response.data=='success') {
					this.toggleQuestions();
					var self = this;
					setTimeout(function() {
						self.alert('<strong>Great!</strong> Your answers have been saved', 'success')
					}, 500);
				}else{
					var self = this;
					this.errors = response.data['errors'];
					if (this.errors == 'Timing issue') {
						$.alert({
							type: 'warning',
							title: 'Error!',
							content: 'Unable to save your answers. Someone else has saved their answers since you loaded the form. Please reload and try again.',
							buttons: {
								OK: {
									text: 'Reload',
									btnClass: 'btn-warning',
									action: function () {
										self.participants = {};
										self.question_groups = {};
										self.getQuestions();
									}
								}
							}
						});
					} else {
						this.alert(this.errors, 'danger', true);
					}
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					this.alert(errors, 'danger', true);
				}
			});

		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},


	}
};
</script>